export default {
  type: "govDingTalk",
  isEnv() {
    return dsf.client.govDingding();
  },
  init(opt = {}) {
    try {
      return new Promise((resolve, reject) => {
        let { sdkUrl } = opt;
        if (!sdkUrl) {
          throw "请传入govDingTalk.sdkUrl";
        }
        dsf.http
          .importFiles(opt.sdkUrl)
          .then(([{ state }]) => {
            // 加载sdk
            if (!state) {
              console.error("钉钉sdk加载出错");
              reject(`${sdkUrl}文件出错`);
            }
            dd.ready(() => {
              authConfig(this.jsApiList)
                .then((res) => {
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    } catch (error) {
      return Promise.reject(error);
    }
  },
  jsApiList: [
    "copyToClipboard",
    "uploadRemoteFileToDisk",
    "chooseSpaceDir",
    "createChatGroup",
    "openChat",
    "createVideoMeeting",
    "createDing",
    "searchOnMap",
    "showOnMap",
    "startGeolocation",
    "locateOnMap",
    "getGeolocation",
    "chooseVideo",
    "chooseDepartments",
    "chooseContactWithComplexPicker",
    "chooseContact",
    "previewDoc",
    "stopAudio",
    "resumeAudio",
    "pauseAudio",
    "playAudio",
    "downloadAudio",
    "stopRecordAudio",
    "stopRecordAudio",
    "onRecordAudioEnd",
    "onAudioPlayEnd",
    "showQuickCallMenu",
    "showCallMenu",
  ],
  methods: {
    /**
     * 选择图片
     * @returns {*}
     */
    chooseImage() {
      return dsf.file.load(".png,.jpg,.gif", true);
    },
    /**
     * 预览图片
     * @param options.current 当前显示图片的http链接
     * @param options.urls 需要预览的图片http链接列表
     * @returns {*}
     */
    previewImage(options = {}) {
      return dd
        .previewImage({
          urls: options.urls || [],
          current: options.current || 1,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {});
    },
    /**
     * 扫码
     * @param options.scanType 可以指定扫二维码还是一维码，默认二者都有
     * @returns {*}
     */
    scan(opt = {}) {
      try {
        let type = "all";
        let inputType = opt.scanType || opt.type;
        if (inputType) {
          type = { qrCode: "qr", barCode: "bar" }[inputType];
        }
        return dd
          ?.scan({
            type,
          })
          .then((res) => {
            return res ? res.text || "" : "";
          });
      } catch (error) {
        reject(error);
      }
    },
    /**
     * 获取地理位置接口
     * @param options.type 默认为wgs84的gps坐标
     */
    getLocation: getGeolocation,
    /**
     * 使用应用内置地图查看位置
     * @param options.latitude 纬度，浮点数，范围为90 ~ -90
     * @param options.longitude 经度，浮点数，范围为180 ~ -180
     */
    openLocation(options = {}) {
      return new Promise((resolve, reject) => {
        try {
          return this.getAuthCode({}).then((res) => {
            if (res.code) {
              return dd
                .locateOnMap({
                  latitude: options.latitude, // 纬度，非必须
                  longitude: options.longitude, // 经度，非必须
                })
                .then(() => {
                  resolve();
                })
                .catch((err) => {
                  reject(err);
                });
            } else {
              reject(res);
            }
          });
        } catch (err) {
          reject(err);
        }
      });
    },
    /**
     * 拨打电话
     * @param options
     * @param options.phoneNumber {string} 手机号码
     */
    callPhone(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          if (!opt.phoneNumber) throw "请传入phoneNumber电话号码";
          dd.biz.telephone.showCallMenu({
            phoneNumber: opt.phoneNumber, // 期望拨打的电话号码
            onSuccess: function () {
              resolve();
            },
            onFail: function () {
              reject();
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取授权码
    getAuthCode(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts({}, opt);
          dd.getAuthCode(_opt)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              reject(err);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取用户详情
    getUserDetails(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts({}, opt);
          return this.getAuthCode({}).then((res) => {
            if (res.code) {
              return dsf.http
                .get("/api/ding/dg/auth/authUserInfo", {
                  authCode: res.code,
                  ..._opt,
                })
                .then(({ data }) => {
                  if (data && data.success) {
                    data = data.data || {};
                    let res = {
                      openid: data.openid,
                      name: data.nickNameCn,
                    };
                    res["_" + this.$type] = data;
                    resolve(res);
                  } else {
                    reject(data);
                  }
                });
            } else {
              reject(res);
            }
          });
        } catch (err) {
          reject(err);
        }
      });
    },
    makePhoneCall(opt) {
      return this.callPhone(opt);
    },
    // 设备唯一标识
    getDeviceCode() {
      return new Promise((resolve, reject) => {
        try {
          dd.device.base.getUUID({
            onSuccess: (data) => {
              resolve(data.uuid);
            },
            onFail: (err) => {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 新开页面
    open(opt = {}) {
      return new Promise((resolve, reject) => {
        let _opt = this._getFuncOpts(
          {
            url: "", // 网址
          },
          opt
        );
        if (!_opt.url) throw "请传入url";
        try {
          dd.biz.util.openLink({
            url: _opt.url, //要打开链接的地址
            onSuccess: function (result) {
              /**/
              resolve();
            },
            onFail: function (err) {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    // 分享
    shareToMessage(opt) {
      try {
        let _opt = this._getFuncOpts(
          {
            url: "",
            title: "",
            content: "",
            image: "",
          },
          opt
        );
        if (!_opt.url) {
          throw "请传入url";
        }
        if (!_opt.title) {
          throw "请传入title";
        }
        return dd.shareToMessage({
          url: _opt.url,
          title: _opt.title,
          content: _opt.content,
          image: _opt.image,
        });
      } catch (error) {
        return Promise.reject(error);
      }
    },
    /**
     * 获取地理位置接口
     * @param options.type 默认为wgs84的gps坐标
     */
    getGeolocation: getGeolocation,
    // 设置 浏览器 title
    navigationSetTitle(opt = {}) {
      return new Promise((resolve, reject) => {
        try {
          let _opt = this._getFuncOpts(
            {
              title: "", // 网址
            },
            opt
          );
          dd.biz.navigation.setTitle({
            title: _opt.title, //控制标题文本，空字符串表示显示默认文本
            onSuccess: function (result) {
              resolve(result);
            },
            onFail: function (err) {
              reject(err);
            },
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};

// 获取定位
function getGeolocation(opt = {}) {
  try {
    // let _opt = this._getFuncOpts(
    //   {
    //     withReGeocodeurl: true,
    //   },
    //   opt
    // );
    let type = 0;
    if (opt.type == "gcj02") {
      type = 1;
    }
    return dd
      .getGeolocation({
        type,
      })
      .then((data) => {
        let res = {
          type: ["wgs84", "gcj02"][type],
          lng: data.longitude,
          lat: data.latitude,
          longitude: data.longitude,
          latitude: data.latitude,
        };
        res["_" + this.$type] = data;
        return Promise.resolve(res);
      });
  } catch (error) {
    return Promise.reject(error);
  }
}

// jsApi鉴权
function authConfig(jsApiList) {
  return getTicket()
    .then(({ data }) => {
      if (data && data.success) {
        return Promise.resolve({ ticket: data?.data?.ticket, jsApiList });
      }
      return Promise.reject(data);
    })
    .then(dd.authConfig);
}

// 获取Ticket
function getTicket() {
  return dsf.http.get("/api/ding/dg/auth/ticket");
}

// 获取Token
function getToken() {
  return dsf.http.get("/api/ding/dg/auth/token");
}
